// Routes and fieldsthat contain PHI and should be excluded from tracking
export const PHI_ROUTES: string[] = [];

export const PHI_FIELDS = [
  'fullname',
  'name',
  'patientName',
  'birthdate',
  'birthDate',
  'dateOfBirth',
  'medatixxId',
  'patientId',
  'email',
  'phone',
  'address',
  'ssn',
  'insurance',
  'diagnosis',
  'anamnesis',
  'findings',
  'therapy',
  'procedure',
  'chiefComplaint',
  'allergies',
  'familyHistory',
  'historyOfPresentIllness',
  'pastMedicalHistory',
  'socialHistory',
  'subjective',
  'surgicalHistory',
  'reviewOfSystems',
  'diagnosticResults',
  'objective',
  'physicalExamination',
  'vitalSigns',
  'medicalDecisionMaking',
  'planOfTreatment',
  'assessment',
  'briefClinicalNotes',
  'discussionNotes',
  'emergencySituationDetails',
  'patientSummary',
  'medications',
  'assessmentAndPlan',
  'ageGender',
  'vaccineName',
  'batchNumber',
  'reason',
];

export const MASKED_TEXT_CLASS = 'masked';
